import { Col } from 'components';
import { useSelector } from 'react-redux';

import { SubscriptionItem } from './components';

const Subscriptions = ({}) => {
  const subscriptions = useSelector((state) => state.subscriptions);

  return (
    <Col marg="16px 0 0" gap="8px" ht="100vh" wid="100%">
      {subscriptions.map((x) => (
        <SubscriptionItem item={x} />
      ))}
    </Col>
  );
};

export default Subscriptions;
